var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"minimart-frontend"},[_c('NavBar'),_c('v-main',[_c('v-container',{staticClass:"pb-5"},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_vm._t("default")],2)],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }